/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module KiteTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface KitePlugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `KitePlugin`'s JSON-Schema
 * via the `definition` "KiteRequestParameters".
 */
export interface KiteRequestParameters {
    /**
     * User prompt text to be processed by Kite engine to generate a function request
     */
    textPrompt: string;
}
/**
 * This interface was referenced by `KitePlugin`'s JSON-Schema
 * via the `definition` "KiteRequestReturn".
 */
export interface KiteRequestReturn {
    /**
     * Function request generated by Kite engine
     */
    funcRequest: string;
    status: Status;
}

/**
 * Status of the Kite request operation
 */
export enum Status {
    KITE_SUCCESS_FUNC_REQUEST = 0,
    KITE_SUCCESS_UNRESOLVED = 1,
    KITE_FAIL_UNKNOWN = 2
}


}
